export const command = {
  search: 'Type a command or search',
  noResults: 'No results',
  actions: 'Actions',
  openMenu: 'Menu',
  manage: 'Manage',
  simulation: 'Simulation',
} as const
